export default __webpack_public_path__ + "static/badge_best_seller-b9533e50b0af4cbe6539cb5c6f588c7d.gif";